<template>
  <div>
    <svg
      class="percent-chart"
      ref="chartSVG"
      viewBox="0 0 546.48 94.38"
      preserveAspectRatio="none"
    >
      <path class="dash" d="M0 47.19 L546.48 47.19" v-if="showDash" />
      <path class="target" :d="targetPoints" />
      <path
        v-for="line in lines"
        :key="line.color"
        :stroke="line.color"
        class="trend-line"
        :d="line.points"
      />
    </svg>
  </div>
</template>

<script>
import { markersMixin } from '@/components/MarkersMixin.js'

export default {
  name: 'PercentChangePlot',
  mixins: [markersMixin],
  props: {
    signals: {
      type: Array,
      required: true
    },
    markers: {
      type: Array,
      required: false
    },
    xMax: {
      type: Number,
      required: true
    },
    xMin: {
      type: Number,
      required: true
    },
    yMax: {
      type: Number,
      required: true
    },
    yMin: {
      type: Number,
      required: true
    },
    targetMin: {
      type: Number,
      required: false,
      default: null
    },
    targetMax: {
      type: Number,
      required: false,
      default: null
    },
    showDash: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      canvasHeight: 94.38,
      canvasWidth: 546.48,
      chartKey: 1,
      markerScale: 2,
      lines: []
    }
  },
  mounted() {
    this.renderSignal()
  },
  watch: {
    signals: function(newSignal, oldSignal) {
      this.renderSignal()
    }
  },
  methods: {
    renderSignal() {
      this.lines = this.signals.map(signal => {
        //this.$refs['trendLine'].style.stroke = signal.color
        let downsampSig = this.downsample(signal.points, 100)
        let scaledSig = this.scaleSignal(downsampSig)
        return {
          points: this.signalToPoints(scaledSig),
          color: signal.color
        }
      })
      //this.markersUpdate(this.$refs['chartSVG'], this.markers)
    },
    downsample(signal, nPoints) {
      if (signal.length <= nPoints) {
        return signal
      }
      let xPerPoint = (signal[signal.length - 1][0] - signal[0][0]) / nPoints
      let windowEnd = signal[0][0] + xPerPoint
      let downsampSig = []
      let xMean = 0
      let yMean = 0
      let count = 0
      downsampSig.push(signal[0])
      for (let i = 1; i < signal.length - 1; i++) {
        xMean += signal[i][0]
        yMean += signal[i][1]
        count++
        if (signal[i][0] > windowEnd) {
          downsampSig.push([xMean / count, yMean / count])
          xMean = yMean = count = 0
          windowEnd = (Math.floor(signal[i][0] / xPerPoint) + 1) * xPerPoint
        }
      }
      downsampSig.push(signal[signal.length - 1])
      return downsampSig
    },
    scaleSignal(signal) {
      return signal.map(el => [
        this.canvasWidth * ((el[0] - this.xMin) / (this.xMax - this.xMin)),
        this.canvasHeight -
          this.canvasHeight * ((el[1] - this.yMin) / (this.yMax - this.yMin))
      ])
    },
    signalToPoints(signal) {
      let points = ''
      let firstPoint = true
      for (const point of signal) {
        if (isNaN(point[1])) {
          firstPoint = true
        } else if (firstPoint) {
          points += `M${point[0]} ${point[1]} `
          firstPoint = false
        } else {
          points += `L${point[0]} ${point[1]} `
        }
      }
      return points
    }
  },
  computed: {
    targetPoints() {
      if (this.targetMin == null || this.targetMax == null) return null
      let upperY =
        this.canvasHeight -
        ((this.targetMax - this.yMin) / (this.yMax - this.yMin)) *
          this.canvasHeight
      let lowerY =
        this.canvasHeight -
        ((this.targetMin - this.yMin) / (this.yMax - this.yMin)) *
          this.canvasHeight
      return `M0 ${lowerY} L${this.canvasWidth} ${lowerY} L${this.canvasWidth} ${upperY} L0 ${upperY} Z`
    }
  }
}
</script>

<style scoped>
.percent-chart {
  display: block;
  height: 100%;
  width: 100%;
  background: #eeeeee;
}
.trend-line {
  stroke-width: 3;
  fill: none;
}
.dash {
  stroke: #818181;
  stroke-dasharray: 5 5;
  stroke-width: 2;
  fill: none;
}
.target {
  stroke: none;
  fill: #c5eecd;
}
</style>
